export enum MatchStatus {
  NotRegistered,
  Inactive,
  NoMatch,
  MultiMatches,
  MemberNumberMismatched,
}

export interface SearchIdentityResult {
  matchStatus?: MatchStatus;
  email?: string;
}

export interface JssSearchIdentityRequest {
  membershipNumber?: string;
  firstName: string;
  lastName: string;
  postcode: string;
  dateOfBirth: string;
}
